import Resolution from 'engine/Resolution.js';
import {
    setResolution,
    setSelectedPianoRollSteps
} from 'actions/index.js';
import {
    updateStepParameter,
    deleteSteps,
    addStep
} from 'operations/actions.js';

const baseResolution = new Resolution(32, false);

export const legato = (track, steps) => {
    let pattern = track.getEasyPattern();
    let stepNumbers = pattern.getStepNumbers(
        steps, baseResolution);
    let oper = track.sequencerEngine.operationManager;
    for (let i=0; i < stepNumbers.length; i++) {
        let [step, stepNumber] = stepNumbers[i];
        let nextStepNumber = getNextStepNumber(track, stepNumber);
        if (nextStepNumber === undefined) {
            continue;
        }
        let duration = (nextStepNumber - stepNumber) / 2;
        oper.dispatch(
            updateStepParameter(
                track,
                step,
                step.durationParameter,
                duration));
    }
};

export const rollSteps = (track, steps) => {
    let pattern = track.getEasyPattern();
    let stepNumbers = pattern.getStepNumbers(
        steps, baseResolution);
    let displayResolution = track.sequencerEngine.state.sequencer.displayResolution;
    let baseSteps = displayResolution.getNumberOfStepsAtBaseResolution();

    let oper = track.sequencerEngine.operationManager;
    let pastedSteps = [];

    for (let i=0; i < stepNumbers.length; i++) {
        let [step, stepNumber] = stepNumbers[i];
        let nextStepNumber = getNextStepNumber(track, stepNumber);
        if (nextStepNumber === undefined) {
            continue;
        }

        for (let copyStep=stepNumber+baseSteps; copyStep < nextStepNumber; copyStep += baseSteps) {
        // copy the step over the resolution until the next step number
            pastedSteps = [
                ... pastedSteps,
                ...pattern.pasteSteps(
                    [step],
                    {stepNumber: copyStep},
                    pattern,
                    baseResolution
                )];
        }
    }

    setSelectedSteps(track, [... steps, ... pastedSteps]);
    track.updateSteps();
};

export const tripletSteps = (track, steps) => {
    let pattern = track.getEasyPattern();
    let displayResolution = track.sequencerEngine.state.sequencer.displayResolution;
    let goalResolution = displayResolution.getCopy();
    let stepNumbers = pattern.getStepNumbers(
        steps, displayResolution);
    goalResolution.isTriplet = !goalResolution.isTriplet;

    track.sequencerEngine.dispatch(setResolution(goalResolution));

    let oper = track.sequencerEngine.operationManager;
    oper.dispatch(
        deleteSteps(track, steps));

    for (let [step, stepNumber] of stepNumbers) {
        let ratio = goalResolution.isTriplet ? 3.0/2.0 : 2.0/3.0;
        oper.dispatch(
            addStep(track, step, Math.round(stepNumber * ratio), goalResolution));
    }
    track.sequencerEngine.dispatch(setResolution(displayResolution));
    track.updateSteps(true, undefined, goalResolution.isTriplet);
};

const setSelectedSteps = ({sequencerEngine}, steps) => {
    sequencerEngine.dispatch(
        setSelectedPianoRollSteps(steps));
};

export const getNextStepNumber = (track, stepNumber, resolution=baseResolution) => {
    stepNumber = baseResolution.transformStepAtResolution2(
        stepNumber, resolution);
    let pattern = track.pattern;
    let stepBuckets = pattern.stepBuckets;
    for (let i=stepNumber+1; i < stepBuckets.length; i++) {
        if (stepBuckets[i].anyOn()) {
            return resolution.transformStepAtResolution2(i, baseResolution);
        }
    }
    return resolution.transformStepAtResolution2(pattern.stepBuckets.length, baseResolution);
};
